<template>
  <div :class="{TA:isTestAchat}">
    <v-select class="select" :options="options" :components="{Deselect}" :searchable="false" :reduce="options => options.value" label="label" :value="value" @input="setSelected" @blur="$emit('blur')"></v-select>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters('subscription', ['isTestAchat']),
    Deselect() { return null}
  },
  props: {
    options: {
      type: Array,
    },
    value: {
      type: String,
    },
  },
  methods: {
    setSelected(value) {
      this.$emit('input', value);
    }
  },
  components: {
    vSelect,
  },
};
</script>

<style lang="scss" scoped>
/deep/ .select .vs__search::placeholder,
/deep/ .select .vs__dropdown-toggle {
  font-family: "ObjectSans", Helvetica, Arial, sans-serif;
  font-size: 1rem;
  padding: 1px 4px;
  border-radius: 4px;
  border: 2px solid $yellow;
  min-width: 100px;

  
}

/deep/ .vs__selected {
  margin: 0;
}

/deep/ .select .vs__dropdown-menu {
  background: $white;
  border: 2px solid $yellow;
  border-top: 0;
  color: $black;
}

.TA {
  /deep/ .select .vs__search::placeholder,
  /deep/ .select .vs__dropdown-toggle { 
    font-family: "Lato", Helvetica, Arial, sans-serif;
    border: 2px solid $pink!important;
  }

  /deep/ .select .vs__dropdown-menu {
    border: 2px solid $pink!important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Form/BecomeFields/SelectField.vue